var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDoubles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M24.364 33.636H4v-6.273c0-1.764 1.055-3.355 2.685-4.032 1.651-.683 4.108-1.33 7.497-1.33 3.389 0 5.846.646 7.496 1.331 1.631.675 2.686 2.267 2.686 4.031v6.273zM24.364 33.636H36V28.93c0-1.323-.753-2.517-1.918-3.023-1.179-.514-2.934-1-5.355-1-1.442 0-3.375.626-4.363.873M14.182 17.636c3.213 0 5.818-2.605 5.818-5.818 0-3.214-2.605-5.819-5.818-5.819-3.213 0-5.818 2.605-5.818 5.819 0 3.213 2.605 5.818 5.818 5.818zM28.727 20.545c2.41 0 4.364-1.954 4.364-4.364s-1.954-4.363-4.364-4.363-4.363 1.953-4.363 4.363 1.953 4.364 4.363 4.364z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDoubles);
export default __webpack_public_path__ + "static/media/icn_doubles.wtn-site.svg";
export { ForwardRef as ReactComponent };